import { render, staticRenderFns } from "./CallRecordList.vue?vue&type=template&id=451c3833&scoped=true"
import script from "./CallRecordList.vue?vue&type=script&lang=js"
export * from "./CallRecordList.vue?vue&type=script&lang=js"
import style0 from "./CallRecordList.vue?vue&type=style&index=0&id=451c3833&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c3833",
  null
  
)

export default component.exports